{
  "en": {
    "Создать кавер": "Create a cover",
    "Загрузите песню": "Upload a song",
    "Свою или ту, на которую у вас есть права": "Your own or one you have the rights to",
    "с {0} до {1}": "from {0} to {1}",
    "Вся песня": "Whole song",
    "Двигайте окно, чтобы выбрать минуту": "Drag the window to pick a minute",
    "Песня короче минуты: прозвучит целиком": "The song is shorter than a minute: it will play in full",
    "Кавер на всю песню": "Cover of the whole song",
    "Окно фрагмента: двигайте по волне": "Clip window: drag along the wave",
    "Выбрать из «Моих треков»": "Choose from “My tracks”",
    "Оригинал": "Original",
    "Голос исполнителя без изменений": "The performer’s voice, unchanged",
    "Мой голос · клон": "My voice · clone",
    "Голоса с переозвучкой, подборки": "Voices that can re-voice, collections",
    "1 минута": "1 minute",
    "Пожелания к стилю": "Style wishes",
    "Что добавить к стилю. Например: женский вокал, медленнее": "What to add to the style. For example: female vocals, slower",
    "Без имён артистов": "No artist names",
    "Описание стиля": "Style description",
    "Опишите стиль": "Describe the style",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Genre, mood, instruments. For example: soul, live drums",
    "Словами, без имён артистов": "In words, no artist names",
    "Читаем песню": "Reading the song",
    "Описание длиннее {0} знаков": "The description is longer than {0} characters",
    "Пожелания к стилю длиннее {0} знаков": "Style wishes are longer than {0} characters",
    "Опишите стиль, от {0} знаков": "Describe the style, at least {0} characters",
    "Стили": "Styles",
    "Искать среди {0} стилей": "Search {0} styles",
    "Мои треки": "My tracks",
    "Каверы и аудио из «Истории»": "Covers and audio from History",
    "Свой стиль": "Custom style",
    "Стиль «{0}»": "Style “{0}”",
    "голос {0}": "voice {0}",
    "голос как в оригинале": "voice as in the original",
    "фрагмент с {0} до {1}": "clip from {0} to {1}",
    "вся песня": "whole song",
    "Слушать вариант {0}": "Listen to option {0}",
    "Делаем кавер": "Making the cover",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "You can leave this screen: the bot will message you when the cover is ready.",
    "Кавер готов": "Cover ready",
    "Изменить стиль": "Change style",
    "Заменить песню": "Replace the song",
    "Права на песню": "Rights to the song",
    "Только свои песни или песни с правами": "Only your own songs or songs you have rights to",
    "Подтверждаю права на эту запись": "I confirm I have the rights to this recording",
    "Подтвердите права на песню": "Confirm the rights to the song",
    "Трек №{0}": "Track #{0}",
    "Своя запись": "My recording",
    "Песня длиннее {0} минут": "The song is longer than {0} minutes",
    "Опишите жанр, настроение и инструменты": "Describe the genre, mood and instruments",
    "за песню": "per song",
    "за фрагмент": "per clip",
    "до {0} минут": "up to {0} minutes",
    "любая минута песни": "any minute of the song",
    "Песня": "Song",
    "за фрагмент {0}": "per clip {0}",
    "Создание кавера пока недоступно": "Creating covers is not available yet",
    "Загружаем песню": "Uploading the song",
    "Загрузите песню заново": "Upload the song again",
    "Песня короче {0} секунд": "The song is shorter than {0} seconds",
    "Пока нет готовых треков": "No finished tracks yet",
    "Не удалось загрузить «Мои треки».": "Couldn’t load “My tracks”.",
    "Запись короче {0} секунд": "The recording is shorter than {0} seconds",
    "Этот трек можно послушать в «Истории»": "You can listen to this track in History",
    "Песня загружена": "Song uploaded",
    "Проверяем права": "Checking the rights",
    "Права проверены": "Rights checked",
    "Отделяем голос от музыки": "Separating the vocals from the music",
    "Голос отделён": "Vocals separated",
    "Играем в новом стиле": "Playing in the new style",
    "Стиль готов": "Style ready",
    "Сводим два варианта": "Mixing two options",
    "Варианты готовы": "Options ready",
    "Песня не прошла проверку": "The song did not pass the check",
    "Не получилось сделать кавер": "Couldn’t make the cover",
    "кавер не создан": "the cover was not created",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Looks like someone else’s recording: we only make covers of your own songs.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "The melody is yours, the sound is new. The bot has already sent both options to the chat, in a separate topic.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "The melody is yours, the sound is new. The bot will send both options to the chat, in a separate topic.",
    "Тут откроется тема чата, куда бот прислал кавер": "This opens the chat topic where the bot sent the cover",
    "Проверьте загрузку песни": "Check the song upload",
    "Читаем длительность песни": "Reading the song length",
    "Песня короче 6 секунд": "The song is shorter than 6 seconds",
    "Выберите стиль": "Choose a style",
    "Выберите голос с переозвучкой": "Choose a voice that can re-voice",
    "Фрагмент 1:00": "Clip 1:00"
  },
  "hy": {
    "Создать кавер": "Ստեղծել քավեր",
    "Загрузите песню": "Վերբեռնեք երգը",
    "Свою или ту, на которую у вас есть права": "Ձերը կամ այնպիսին, որի իրավունքներն ունեք",
    "с {0} до {1}": "{0}-ից մինչև {1}",
    "Вся песня": "Ամբողջ երգը",
    "Двигайте окно, чтобы выбрать минуту": "Տեղաշարժեք պատուհանը՝ րոպեն ընտրելու համար",
    "Песня короче минуты: прозвучит целиком": "Երգը մեկ րոպեից կարճ է․ կհնչի ամբողջությամբ",
    "Кавер на всю песню": "Քավեր ամբողջ երգի վրա",
    "Окно фрагмента: двигайте по волне": "Հատվածի պատուհան․ տեղաշարժեք ալիքի վրայով",
    "Выбрать из «Моих треков»": "Ընտրել «Իմ թրեքերից»",
    "Оригинал": "Բնօրինակ",
    "Голос исполнителя без изменений": "Կատարողի ձայնն առանց փոփոխության",
    "Мой голос · клон": "Իմ ձայնը · կլոն",
    "Голоса с переозвучкой, подборки": "Վերահնչյունավորող ձայներ, ընտրանիներ",
    "1 минута": "1 րոպե",
    "Пожелания к стилю": "Ոճի ցանկություններ",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Ինչ ավելացնել ոճին։ Օրինակ՝ կանացի վոկալ, ավելի դանդաղ",
    "Без имён артистов": "Առանց արտիստների անունների",
    "Описание стиля": "Ոճի նկարագրություն",
    "Опишите стиль": "Նկարագրեք ոճը",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Ժանր, տրամադրություն, գործիքներ։ Օրինակ՝ սոուլ, կենդանի հարվածային",
    "Словами, без имён артистов": "Բառերով, առանց արտիստների անունների",
    "Читаем песню": "Կարդում ենք երգը",
    "Описание длиннее {0} знаков": "Նկարագրությունը {0} նիշից երկար է",
    "Пожелания к стилю длиннее {0} знаков": "Ոճի ցանկությունները {0} նիշից երկար են",
    "Опишите стиль, от {0} знаков": "Նկարագրեք ոճը, առնվազն {0} նիշ",
    "Стили": "Ոճեր",
    "Искать среди {0} стилей": "Որոնել {0} ոճերի մեջ",
    "Мои треки": "Իմ թրեքերը",
    "Каверы и аудио из «Истории»": "Քավերներ և աուդիո «Պատմությունից»",
    "Свой стиль": "Սեփական ոճ",
    "Стиль «{0}»": "«{0}» ոճ",
    "голос {0}": "ձայն՝ {0}",
    "голос как в оригинале": "ձայնը՝ ինչպես բնօրինակում",
    "фрагмент с {0} до {1}": "հատված {0}-ից մինչև {1}",
    "вся песня": "ամբողջ երգը",
    "Слушать вариант {0}": "Լսել {0}-րդ տարբերակը",
    "Делаем кавер": "Ստեղծում ենք քավերը",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ քավերը պատրաստ լինի։",
    "Кавер готов": "Քավերը պատրաստ է",
    "Изменить стиль": "Փոխել ոճը",
    "Заменить песню": "Փոխարինել երգը",
    "Права на песню": "Երգի իրավունքներ",
    "Только свои песни или песни с правами": "Միայն ձեր երգերը կամ այն երգերը, որոնց իրավունքներն ունեք",
    "Подтверждаю права на эту запись": "Հաստատում եմ այս ձայնագրության իրավունքները",
    "Подтвердите права на песню": "Հաստատեք երգի իրավունքները",
    "Трек №{0}": "Թրեք №{0}",
    "Своя запись": "Իմ ձայնագրությունը",
    "Песня длиннее {0} минут": "Երգը {0} րոպեից երկար է",
    "Опишите жанр, настроение и инструменты": "Նկարագրեք ժանրը, տրամադրությունը և գործիքները",
    "за песню": "երգի համար",
    "за фрагмент": "հատվածի համար",
    "до {0} минут": "մինչև {0} րոպե",
    "любая минута песни": "երգի ցանկացած րոպե",
    "Песня": "Երգ",
    "за фрагмент {0}": "հատվածի համար {0}",
    "Создание кавера пока недоступно": "Քավերի ստեղծումը դեռ հասանելի չէ",
    "Загружаем песню": "Վերբեռնում ենք երգը",
    "Загрузите песню заново": "Վերբեռնեք երգը կրկին",
    "Песня короче {0} секунд": "Երգը {0} վայրկյանից կարճ է",
    "Пока нет готовых треков": "Պատրաստի թրեքեր դեռ չկան",
    "Не удалось загрузить «Мои треки».": "Չհաջողվեց բեռնել «Իմ թրեքերը»։",
    "Запись короче {0} секунд": "Ձայնագրությունը {0} վայրկյանից կարճ է",
    "Этот трек можно послушать в «Истории»": "Այս թրեքը կարող եք լսել «Պատմությունում»",
    "Песня загружена": "Երգը վերբեռնված է",
    "Проверяем права": "Ստուգում ենք իրավունքները",
    "Права проверены": "Իրավունքները ստուգված են",
    "Отделяем голос от музыки": "Ձայնն առանձնացնում ենք երաժշտությունից",
    "Голос отделён": "Ձայնն առանձնացված է",
    "Играем в новом стиле": "Նվագում ենք նոր ոճով",
    "Стиль готов": "Ոճը պատրաստ է",
    "Сводим два варианта": "Միքսում ենք երկու տարբերակ",
    "Варианты готовы": "Տարբերակները պատրաստ են",
    "Песня не прошла проверку": "Երգը չանցավ ստուգումը",
    "Не получилось сделать кавер": "Չհաջողվեց ստեղծել քավերը",
    "кавер не создан": "քավերը չի ստեղծվել",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Կարծես ուրիշի ձայնագրություն է․ քավերներ ենք անում միայն ձեր սեփական երգերի համար։",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "Մեղեդին ձերն է, հնչողությունը՝ նոր։ Բոտն արդեն ուղարկել է երկու տարբերակն էլ չաթ՝ առանձին թեմայով։",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "Մեղեդին ձերն է, հնչողությունը՝ նոր։ Բոտը կուղարկի երկու տարբերակն էլ չաթ՝ առանձին թեմայով։",
    "Тут откроется тема чата, куда бот прислал кавер": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է քավերը",
    "Проверьте загрузку песни": "Ստուգեք երգի վերբեռնումը",
    "Читаем длительность песни": "Կարդում ենք երգի տևողությունը",
    "Песня короче 6 секунд": "Երգը 6 վայրկյանից կարճ է",
    "Выберите стиль": "Ընտրեք ոճ",
    "Выберите голос с переозвучкой": "Ընտրեք վերահնչյունավորող ձայն",
    "Фрагмент 1:00": "Հատված 1:00"
  },
  "es": {
    "Создать кавер": "Crear un cover",
    "Загрузите песню": "Sube una canción",
    "Свою или ту, на которую у вас есть права": "Tuya o una sobre la que tengas los derechos",
    "с {0} до {1}": "de {0} a {1}",
    "Вся песня": "Canción completa",
    "Двигайте окно, чтобы выбрать минуту": "Mueve la ventana para elegir un minuto",
    "Песня короче минуты: прозвучит целиком": "La canción dura menos de un minuto: sonará entera",
    "Кавер на всю песню": "Cover de la canción completa",
    "Окно фрагмента: двигайте по волне": "Ventana del fragmento: muévela por la onda",
    "Выбрать из «Моих треков»": "Elegir de «Mis pistas»",
    "Оригинал": "Original",
    "Голос исполнителя без изменений": "La voz del intérprete sin cambios",
    "Мой голос · клон": "Mi voz · clon",
    "Голоса с переозвучкой, подборки": "Voces con redoblaje, colecciones",
    "1 минута": "1 minuto",
    "Пожелания к стилю": "Preferencias de estilo",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Qué añadir al estilo. Por ejemplo: voz femenina, más lento",
    "Без имён артистов": "Sin nombres de artistas",
    "Описание стиля": "Descripción del estilo",
    "Опишите стиль": "Describe el estilo",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Género, ambiente, instrumentos. Por ejemplo: soul, batería en directo",
    "Словами, без имён артистов": "Con palabras, sin nombres de artistas",
    "Читаем песню": "Leyendo la canción",
    "Описание длиннее {0} знаков": "La descripción supera los {0} caracteres",
    "Пожелания к стилю длиннее {0} знаков": "Las preferencias de estilo superan los {0} caracteres",
    "Опишите стиль, от {0} знаков": "Describe el estilo, mínimo {0} caracteres",
    "Стили": "Estilos",
    "Искать среди {0} стилей": "Buscar entre {0} estilos",
    "Мои треки": "Mis pistas",
    "Каверы и аудио из «Истории»": "Covers y audio del «Historial»",
    "Свой стиль": "Estilo propio",
    "Стиль «{0}»": "Estilo «{0}»",
    "голос {0}": "voz {0}",
    "голос как в оригинале": "voz como en el original",
    "фрагмент с {0} до {1}": "fragmento de {0} a {1}",
    "вся песня": "canción completa",
    "Слушать вариант {0}": "Escuchar la opción {0}",
    "Делаем кавер": "Creando el cover",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Puedes salir de la pantalla: el bot te escribirá cuando el cover esté listo.",
    "Кавер готов": "Cover listo",
    "Изменить стиль": "Cambiar estilo",
    "Заменить песню": "Reemplazar la canción",
    "Права на песню": "Derechos sobre la canción",
    "Только свои песни или песни с правами": "Solo canciones propias o con derechos",
    "Подтверждаю права на эту запись": "Confirmo que tengo los derechos de esta grabación",
    "Подтвердите права на песню": "Confirma los derechos sobre la canción",
    "Трек №{0}": "Pista n.º {0}",
    "Своя запись": "Grabación propia",
    "Песня длиннее {0} минут": "La canción dura más de {0} minutos",
    "Опишите жанр, настроение и инструменты": "Describe el género, el ambiente y los instrumentos",
    "за песню": "por canción",
    "за фрагмент": "por fragmento",
    "до {0} минут": "hasta {0} minutos",
    "любая минута песни": "cualquier minuto de la canción",
    "Песня": "Canción",
    "за фрагмент {0}": "por fragmento {0}",
    "Создание кавера пока недоступно": "La creación de covers aún no está disponible",
    "Загружаем песню": "Subiendo la canción",
    "Загрузите песню заново": "Vuelve a subir la canción",
    "Песня короче {0} секунд": "La canción dura menos de {0} segundos",
    "Пока нет готовых треков": "Aún no hay pistas listas",
    "Не удалось загрузить «Мои треки».": "No se pudo cargar «Mis pistas».",
    "Запись короче {0} секунд": "La grabación dura menos de {0} segundos",
    "Этот трек можно послушать в «Истории»": "Puedes escuchar esta pista en el «Historial»",
    "Песня загружена": "Canción subida",
    "Проверяем права": "Comprobando los derechos",
    "Права проверены": "Derechos comprobados",
    "Отделяем голос от музыки": "Separando la voz de la música",
    "Голос отделён": "Voz separada",
    "Играем в новом стиле": "Tocando en el nuevo estilo",
    "Стиль готов": "Estilo listo",
    "Сводим два варианта": "Mezclando dos opciones",
    "Варианты готовы": "Opciones listas",
    "Песня не прошла проверку": "La canción no superó la comprobación",
    "Не получилось сделать кавер": "No se pudo crear el cover",
    "кавер не создан": "el cover no se creó",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Parece una grabación ajena: solo hacemos covers de tus propias canciones.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "La melodía es tuya, el sonido es nuevo. El bot ya envió las dos opciones al chat, en un tema aparte.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "La melodía es tuya, el sonido es nuevo. El bot enviará las dos opciones al chat, en un tema aparte.",
    "Тут откроется тема чата, куда бот прислал кавер": "Aquí se abrirá el tema del chat donde el bot envió el cover",
    "Проверьте загрузку песни": "Comprueba la subida de la canción",
    "Читаем длительность песни": "Leyendo la duración de la canción",
    "Песня короче 6 секунд": "La canción dura menos de 6 segundos",
    "Выберите стиль": "Elige un estilo",
    "Выберите голос с переозвучкой": "Elige una voz con redoblaje",
    "Фрагмент 1:00": "Fragmento 1:00"
  },
  "de": {
    "Создать кавер": "Coverversion erstellen",
    "Загрузите песню": "Laden Sie einen Song hoch",
    "Свою или ту, на которую у вас есть права": "Ihren eigenen oder einen, an dem Sie die Rechte haben",
    "с {0} до {1}": "von {0} bis {1}",
    "Вся песня": "Ganzer Song",
    "Двигайте окно, чтобы выбрать минуту": "Verschieben Sie das Fenster, um eine Minute zu wählen",
    "Песня короче минуты: прозвучит целиком": "Der Song ist kürzer als eine Minute: Er wird ganz gespielt",
    "Кавер на всю песню": "Coverversion des ganzen Songs",
    "Окно фрагмента: двигайте по волне": "Ausschnittsfenster: entlang der Welle verschieben",
    "Выбрать из «Моих треков»": "Aus „Meine Tracks“ wählen",
    "Оригинал": "Original",
    "Голос исполнителя без изменений": "Stimme des Interpreten unverändert",
    "Мой голос · клон": "Meine Stimme · Klon",
    "Голоса с переозвучкой, подборки": "Stimmen mit Neuvertonung, Sammlungen",
    "1 минута": "1 Minute",
    "Пожелания к стилю": "Wünsche zum Stil",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Was zum Stil hinzufügen. Zum Beispiel: weiblicher Gesang, langsamer",
    "Без имён артистов": "Ohne Künstlernamen",
    "Описание стиля": "Stilbeschreibung",
    "Опишите стиль": "Beschreiben Sie den Stil",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Genre, Stimmung, Instrumente. Zum Beispiel: Soul, Live-Schlagzeug",
    "Словами, без имён артистов": "In Worten, ohne Künstlernamen",
    "Читаем песню": "Song wird gelesen",
    "Описание длиннее {0} знаков": "Die Beschreibung ist länger als {0} Zeichen",
    "Пожелания к стилю длиннее {0} знаков": "Die Wünsche zum Stil sind länger als {0} Zeichen",
    "Опишите стиль, от {0} знаков": "Beschreiben Sie den Stil, mindestens {0} Zeichen",
    "Стили": "Stile",
    "Искать среди {0} стилей": "In {0} Stilen suchen",
    "Мои треки": "Meine Tracks",
    "Каверы и аудио из «Истории»": "Coverversionen und Audio aus dem Verlauf",
    "Свой стиль": "Eigener Stil",
    "Стиль «{0}»": "Stil „{0}“",
    "голос {0}": "Stimme {0}",
    "голос как в оригинале": "Stimme wie im Original",
    "фрагмент с {0} до {1}": "Ausschnitt von {0} bis {1}",
    "вся песня": "ganzer Song",
    "Слушать вариант {0}": "Variante {0} anhören",
    "Делаем кавер": "Coverversion wird erstellt",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Sie können den Bildschirm verlassen: Der Bot schreibt Ihnen, wenn die Coverversion fertig ist.",
    "Кавер готов": "Coverversion fertig",
    "Изменить стиль": "Stil ändern",
    "Заменить песню": "Song ersetzen",
    "Права на песню": "Rechte am Song",
    "Только свои песни или песни с правами": "Nur eigene Songs oder Songs, an denen Sie die Rechte haben",
    "Подтверждаю права на эту запись": "Ich bestätige die Rechte an dieser Aufnahme",
    "Подтвердите права на песню": "Bestätigen Sie die Rechte am Song",
    "Трек №{0}": "Track Nr. {0}",
    "Своя запись": "Eigene Aufnahme",
    "Песня длиннее {0} минут": "Der Song ist länger als {0} Minuten",
    "Опишите жанр, настроение и инструменты": "Beschreiben Sie Genre, Stimmung und Instrumente",
    "за песню": "pro Song",
    "за фрагмент": "pro Ausschnitt",
    "до {0} минут": "bis {0} Minuten",
    "любая минута песни": "eine beliebige Minute des Songs",
    "Песня": "Song",
    "за фрагмент {0}": "pro Ausschnitt {0}",
    "Создание кавера пока недоступно": "Coverversionen sind noch nicht verfügbar",
    "Загружаем песню": "Song wird hochgeladen",
    "Загрузите песню заново": "Laden Sie den Song erneut hoch",
    "Песня короче {0} секунд": "Der Song ist kürzer als {0} Sekunden",
    "Пока нет готовых треков": "Noch keine fertigen Tracks",
    "Не удалось загрузить «Мои треки».": "„Meine Tracks“ konnten nicht geladen werden.",
    "Запись короче {0} секунд": "Die Aufnahme ist kürzer als {0} Sekunden",
    "Этот трек можно послушать в «Истории»": "Diesen Track können Sie im Verlauf anhören",
    "Песня загружена": "Song hochgeladen",
    "Проверяем права": "Rechte werden geprüft",
    "Права проверены": "Rechte geprüft",
    "Отделяем голос от музыки": "Gesang wird von der Musik getrennt",
    "Голос отделён": "Gesang getrennt",
    "Играем в новом стиле": "Spielen im neuen Stil",
    "Стиль готов": "Stil fertig",
    "Сводим два варианта": "Zwei Varianten werden abgemischt",
    "Варианты готовы": "Varianten fertig",
    "Песня не прошла проверку": "Der Song hat die Prüfung nicht bestanden",
    "Не получилось сделать кавер": "Die Coverversion konnte nicht erstellt werden",
    "кавер не создан": "die Coverversion wurde nicht erstellt",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Das sieht nach einer fremden Aufnahme aus: Coverversionen machen wir nur von eigenen Songs.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "Die Melodie gehört Ihnen, der Klang ist neu. Der Bot hat beide Varianten bereits in den Chat geschickt, in ein eigenes Thema.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "Die Melodie gehört Ihnen, der Klang ist neu. Der Bot schickt beide Varianten in den Chat, in ein eigenes Thema.",
    "Тут откроется тема чата, куда бот прислал кавер": "Hier öffnet sich das Chat-Thema, in das der Bot die Coverversion geschickt hat",
    "Проверьте загрузку песни": "Prüfen Sie den Upload des Songs",
    "Читаем длительность песни": "Songlänge wird gelesen",
    "Песня короче 6 секунд": "Der Song ist kürzer als 6 Sekunden",
    "Выберите стиль": "Wählen Sie einen Stil",
    "Выберите голос с переозвучкой": "Wählen Sie eine Stimme mit Neuvertonung",
    "Фрагмент 1:00": "Ausschnitt 1:00"
  },
  "fr": {
    "Создать кавер": "Créer une reprise",
    "Загрузите песню": "Importez une chanson",
    "Свою или ту, на которую у вас есть права": "La vôtre ou une dont vous avez les droits",
    "с {0} до {1}": "de {0} à {1}",
    "Вся песня": "Chanson entière",
    "Двигайте окно, чтобы выбрать минуту": "Déplacez la fenêtre pour choisir une minute",
    "Песня короче минуты: прозвучит целиком": "La chanson dure moins d’une minute : elle sera jouée en entier",
    "Кавер на всю песню": "Reprise de la chanson entière",
    "Окно фрагмента: двигайте по волне": "Fenêtre de l’extrait : faites-la glisser sur l’onde",
    "Выбрать из «Моих треков»": "Choisir dans « Mes morceaux »",
    "Оригинал": "Original",
    "Голос исполнителя без изменений": "La voix de l’interprète sans changement",
    "Мой голос · клон": "Ma voix · clone",
    "Голоса с переозвучкой, подборки": "Voix avec redoublage, sélections",
    "1 минута": "1 minute",
    "Пожелания к стилю": "Souhaits pour le style",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Ce qu’il faut ajouter au style. Par exemple : voix féminine, plus lent",
    "Без имён артистов": "Sans noms d’artistes",
    "Описание стиля": "Description du style",
    "Опишите стиль": "Décrivez le style",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Genre, ambiance, instruments. Par exemple : soul, batterie live",
    "Словами, без имён артистов": "Avec des mots, sans noms d’artistes",
    "Читаем песню": "Lecture de la chanson",
    "Описание длиннее {0} знаков": "La description dépasse {0} caractères",
    "Пожелания к стилю длиннее {0} знаков": "Les souhaits pour le style dépassent {0} caractères",
    "Опишите стиль, от {0} знаков": "Décrivez le style, au moins {0} caractères",
    "Стили": "Styles",
    "Искать среди {0} стилей": "Rechercher parmi {0} styles",
    "Мои треки": "Mes morceaux",
    "Каверы и аудио из «Истории»": "Reprises et audio de l’« Historique »",
    "Свой стиль": "Style personnalisé",
    "Стиль «{0}»": "Style « {0} »",
    "голос {0}": "voix {0}",
    "голос как в оригинале": "voix comme dans l’original",
    "фрагмент с {0} до {1}": "extrait de {0} à {1}",
    "вся песня": "chanson entière",
    "Слушать вариант {0}": "Écouter la variante {0}",
    "Делаем кавер": "Création de la reprise",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Vous pouvez quitter l’écran : le bot vous écrira quand la reprise sera prête.",
    "Кавер готов": "Reprise prête",
    "Изменить стиль": "Changer de style",
    "Заменить песню": "Remplacer la chanson",
    "Права на песню": "Droits sur la chanson",
    "Только свои песни или песни с правами": "Uniquement vos chansons ou des chansons dont vous avez les droits",
    "Подтверждаю права на эту запись": "Je confirme détenir les droits sur cet enregistrement",
    "Подтвердите права на песню": "Confirmez les droits sur la chanson",
    "Трек №{0}": "Morceau n° {0}",
    "Своя запись": "Mon enregistrement",
    "Песня длиннее {0} минут": "La chanson dure plus de {0} minutes",
    "Опишите жанр, настроение и инструменты": "Décrivez le genre, l’ambiance et les instruments",
    "за песню": "par chanson",
    "за фрагмент": "par extrait",
    "до {0} минут": "jusqu’à {0} minutes",
    "любая минута песни": "n’importe quelle minute de la chanson",
    "Песня": "Chanson",
    "за фрагмент {0}": "par extrait {0}",
    "Создание кавера пока недоступно": "La création de reprises n’est pas encore disponible",
    "Загружаем песню": "Import de la chanson",
    "Загрузите песню заново": "Importez à nouveau la chanson",
    "Песня короче {0} секунд": "La chanson dure moins de {0} secondes",
    "Пока нет готовых треков": "Aucun morceau terminé pour l’instant",
    "Не удалось загрузить «Мои треки».": "Impossible de charger « Mes morceaux ».",
    "Запись короче {0} секунд": "L’enregistrement dure moins de {0} secondes",
    "Этот трек можно послушать в «Истории»": "Vous pouvez écouter ce morceau dans l’« Historique »",
    "Песня загружена": "Chanson importée",
    "Проверяем права": "Vérification des droits",
    "Права проверены": "Droits vérifiés",
    "Отделяем голос от музыки": "Séparation de la voix et de la musique",
    "Голос отделён": "Voix séparée",
    "Играем в новом стиле": "Interprétation dans le nouveau style",
    "Стиль готов": "Style prêt",
    "Сводим два варианта": "Mixage de deux variantes",
    "Варианты готовы": "Variantes prêtes",
    "Песня не прошла проверку": "La chanson n’a pas passé la vérification",
    "Не получилось сделать кавер": "Impossible de créer la reprise",
    "кавер не создан": "la reprise n’a pas été créée",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "On dirait l’enregistrement de quelqu’un d’autre : nous ne faisons des reprises que de vos propres chansons.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "La mélodie est la vôtre, le son est nouveau. Le bot a déjà envoyé les deux variantes dans le chat, dans un sujet à part.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "La mélodie est la vôtre, le son est nouveau. Le bot enverra les deux variantes dans le chat, dans un sujet à part.",
    "Тут откроется тема чата, куда бот прислал кавер": "Ici s’ouvrira le sujet du chat où le bot a envoyé la reprise",
    "Проверьте загрузку песни": "Vérifiez l’import de la chanson",
    "Читаем длительность песни": "Lecture de la durée de la chanson",
    "Песня короче 6 секунд": "La chanson dure moins de 6 secondes",
    "Выберите стиль": "Choisissez un style",
    "Выберите голос с переозвучкой": "Choisissez une voix avec redoublage",
    "Фрагмент 1:00": "Extrait 1:00"
  },
  "pt": {
    "Создать кавер": "Criar cover",
    "Загрузите песню": "Envie uma música",
    "Свою или ту, на которую у вас есть права": "Sua ou uma da qual você tem os direitos",
    "с {0} до {1}": "de {0} a {1}",
    "Вся песня": "Música inteira",
    "Двигайте окно, чтобы выбрать минуту": "Arraste a janela para escolher um minuto",
    "Песня короче минуты: прозвучит целиком": "A música tem menos de um minuto: vai tocar inteira",
    "Кавер на всю песню": "Cover da música inteira",
    "Окно фрагмента: двигайте по волне": "Janela do trecho: arraste pela onda",
    "Выбрать из «Моих треков»": "Escolher em «Minhas faixas»",
    "Оригинал": "Original",
    "Голос исполнителя без изменений": "A voz do intérprete sem alterações",
    "Мой голос · клон": "Minha voz · clone",
    "Голоса с переозвучкой, подборки": "Vozes com redublagem, coleções",
    "1 минута": "1 minuto",
    "Пожелания к стилю": "Preferências de estilo",
    "Что добавить к стилю. Например: женский вокал, медленнее": "O que adicionar ao estilo. Por exemplo: vocal feminino, mais lento",
    "Без имён артистов": "Sem nomes de artistas",
    "Описание стиля": "Descrição do estilo",
    "Опишите стиль": "Descreva o estilo",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Gênero, clima, instrumentos. Por exemplo: soul, bateria ao vivo",
    "Словами, без имён артистов": "Com palavras, sem nomes de artistas",
    "Читаем песню": "Lendo a música",
    "Описание длиннее {0} знаков": "A descrição tem mais de {0} caracteres",
    "Пожелания к стилю длиннее {0} знаков": "As preferências de estilo têm mais de {0} caracteres",
    "Опишите стиль, от {0} знаков": "Descreva o estilo, no mínimo {0} caracteres",
    "Стили": "Estilos",
    "Искать среди {0} стилей": "Pesquisar entre {0} estilos",
    "Мои треки": "Minhas faixas",
    "Каверы и аудио из «Истории»": "Covers e áudio do «Histórico»",
    "Свой стиль": "Estilo próprio",
    "Стиль «{0}»": "Estilo «{0}»",
    "голос {0}": "voz {0}",
    "голос как в оригинале": "voz como no original",
    "фрагмент с {0} до {1}": "trecho de {0} a {1}",
    "вся песня": "música inteira",
    "Слушать вариант {0}": "Ouvir a opção {0}",
    "Делаем кавер": "Criando o cover",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Você pode sair da tela: o bot vai avisar quando o cover estiver pronto.",
    "Кавер готов": "Cover pronto",
    "Изменить стиль": "Mudar estilo",
    "Заменить песню": "Substituir a música",
    "Права на песню": "Direitos sobre a música",
    "Только свои песни или песни с правами": "Só músicas suas ou com direitos",
    "Подтверждаю права на эту запись": "Confirmo que tenho os direitos desta gravação",
    "Подтвердите права на песню": "Confirme os direitos sobre a música",
    "Трек №{0}": "Faixa nº {0}",
    "Своя запись": "Gravação própria",
    "Песня длиннее {0} минут": "A música tem mais de {0} minutos",
    "Опишите жанр, настроение и инструменты": "Descreva o gênero, o clima e os instrumentos",
    "за песню": "por música",
    "за фрагмент": "por trecho",
    "до {0} минут": "até {0} minutos",
    "любая минута песни": "qualquer minuto da música",
    "Песня": "Música",
    "за фрагмент {0}": "por trecho {0}",
    "Создание кавера пока недоступно": "A criação de covers ainda não está disponível",
    "Загружаем песню": "Enviando a música",
    "Загрузите песню заново": "Envie a música novamente",
    "Песня короче {0} секунд": "A música tem menos de {0} segundos",
    "Пока нет готовых треков": "Ainda não há faixas prontas",
    "Не удалось загрузить «Мои треки».": "Não foi possível carregar «Minhas faixas».",
    "Запись короче {0} секунд": "A gravação tem menos de {0} segundos",
    "Этот трек можно послушать в «Истории»": "Você pode ouvir esta faixa no «Histórico»",
    "Песня загружена": "Música enviada",
    "Проверяем права": "Verificando os direitos",
    "Права проверены": "Direitos verificados",
    "Отделяем голос от музыки": "Separando a voz da música",
    "Голос отделён": "Voz separada",
    "Играем в новом стиле": "Tocando no novo estilo",
    "Стиль готов": "Estilo pronto",
    "Сводим два варианта": "Mixando duas opções",
    "Варианты готовы": "Opções prontas",
    "Песня не прошла проверку": "A música não passou na verificação",
    "Не получилось сделать кавер": "Não foi possível criar o cover",
    "кавер не создан": "o cover não foi criado",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Parece a gravação de outra pessoa: só fazemos covers das suas próprias músicas.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "A melodia é sua, o som é novo. O bot já enviou as duas opções para o chat, em um tópico separado.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "A melodia é sua, o som é novo. O bot vai enviar as duas opções para o chat, em um tópico separado.",
    "Тут откроется тема чата, куда бот прислал кавер": "Aqui vai abrir o tópico do chat onde o bot enviou o cover",
    "Проверьте загрузку песни": "Verifique o envio da música",
    "Читаем длительность песни": "Lendo a duração da música",
    "Песня короче 6 секунд": "A música tem menos de 6 segundos",
    "Выберите стиль": "Escolha um estilo",
    "Выберите голос с переозвучкой": "Escolha uma voz com redublagem",
    "Фрагмент 1:00": "Trecho 1:00"
  },
  "tr": {
    "Создать кавер": "Cover oluştur",
    "Загрузите песню": "Bir şarkı yükleyin",
    "Свою или ту, на которую у вас есть права": "Kendi şarkınız ya da haklarına sahip olduğunuz bir şarkı",
    "с {0} до {1}": "{0} ile {1} arası",
    "Вся песня": "Şarkının tamamı",
    "Двигайте окно, чтобы выбрать минуту": "Bir dakika seçmek için pencereyi kaydırın",
    "Песня короче минуты: прозвучит целиком": "Şarkı bir dakikadan kısa: tamamı çalınacak",
    "Кавер на всю песню": "Şarkının tamamının cover’ı",
    "Окно фрагмента: двигайте по волне": "Kesit penceresi: dalga boyunca kaydırın",
    "Выбрать из «Моих треков»": "«Parçalarım» içinden seç",
    "Оригинал": "Orijinal",
    "Голос исполнителя без изменений": "Sanatçının sesi, değişmeden",
    "Мой голос · клон": "Sesim · klon",
    "Голоса с переозвучкой, подборки": "Yeniden seslendirme yapabilen sesler, koleksiyonlar",
    "1 минута": "1 dakika",
    "Пожелания к стилю": "Stil istekleri",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Stile ne eklensin. Örneğin: kadın vokal, daha yavaş",
    "Без имён артистов": "Sanatçı adı olmadan",
    "Описание стиля": "Stil açıklaması",
    "Опишите стиль": "Stili tanımlayın",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Tür, ruh hâli, enstrümanlar. Örneğin: soul, canlı davul",
    "Словами, без имён артистов": "Kelimelerle, sanatçı adı olmadan",
    "Читаем песню": "Şarkı okunuyor",
    "Описание длиннее {0} знаков": "Açıklama {0} karakterden uzun",
    "Пожелания к стилю длиннее {0} знаков": "Stil istekleri {0} karakterden uzun",
    "Опишите стиль, от {0} знаков": "Stili tanımlayın, en az {0} karakter",
    "Стили": "Stiller",
    "Искать среди {0} стилей": "{0} stil içinde ara",
    "Мои треки": "Parçalarım",
    "Каверы и аудио из «Истории»": "«Geçmiş» içindeki cover’lar ve sesler",
    "Свой стиль": "Kendi stilim",
    "Стиль «{0}»": "«{0}» stili",
    "голос {0}": "ses {0}",
    "голос как в оригинале": "orijinaldeki gibi ses",
    "фрагмент с {0} до {1}": "kesit {0} ile {1} arası",
    "вся песня": "şarkının tamamı",
    "Слушать вариант {0}": "{0}. seçeneği dinle",
    "Делаем кавер": "Cover hazırlanıyor",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Ekrandan ayrılabilirsiniz: cover hazır olduğunda bot size yazacak.",
    "Кавер готов": "Cover hazır",
    "Изменить стиль": "Stili değiştir",
    "Заменить песню": "Şarkıyı değiştir",
    "Права на песню": "Şarkının hakları",
    "Только свои песни или песни с правами": "Yalnızca kendi şarkılarınız ya da haklarına sahip olduğunuz şarkılar",
    "Подтверждаю права на эту запись": "Bu kaydın haklarına sahip olduğumu onaylıyorum",
    "Подтвердите права на песню": "Şarkının haklarını onaylayın",
    "Трек №{0}": "Parça No. {0}",
    "Своя запись": "Kendi kaydım",
    "Песня длиннее {0} минут": "Şarkı {0} dakikadan uzun",
    "Опишите жанр, настроение и инструменты": "Türü, ruh hâlini ve enstrümanları tanımlayın",
    "за песню": "şarkı başına",
    "за фрагмент": "kesit başına",
    "до {0} минут": "{0} dakikaya kadar",
    "любая минута песни": "şarkının herhangi bir dakikası",
    "Песня": "Şarkı",
    "за фрагмент {0}": "kesit başına {0}",
    "Создание кавера пока недоступно": "Cover oluşturma henüz kullanılamıyor",
    "Загружаем песню": "Şarkı yükleniyor",
    "Загрузите песню заново": "Şarkıyı yeniden yükleyin",
    "Песня короче {0} секунд": "Şarkı {0} saniyeden kısa",
    "Пока нет готовых треков": "Henüz hazır parça yok",
    "Не удалось загрузить «Мои треки».": "«Parçalarım» yüklenemedi.",
    "Запись короче {0} секунд": "Kayıt {0} saniyeden kısa",
    "Этот трек можно послушать в «Истории»": "Bu parçayı «Geçmiş» bölümünde dinleyebilirsiniz",
    "Песня загружена": "Şarkı yüklendi",
    "Проверяем права": "Haklar kontrol ediliyor",
    "Права проверены": "Haklar kontrol edildi",
    "Отделяем голос от музыки": "Vokal müzikten ayrılıyor",
    "Голос отделён": "Vokal ayrıldı",
    "Играем в новом стиле": "Yeni stilde çalınıyor",
    "Стиль готов": "Stil hazır",
    "Сводим два варианта": "İki seçenek miksleniyor",
    "Варианты готовы": "Seçenekler hazır",
    "Песня не прошла проверку": "Şarkı kontrolden geçmedi",
    "Не получилось сделать кавер": "Cover oluşturulamadı",
    "кавер не создан": "cover oluşturulmadı",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Başkasının kaydına benziyor: yalnızca kendi şarkılarınızın cover’ını yapıyoruz.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "Melodi sizin, ses yeni. Bot iki seçeneği de sohbete, ayrı bir konuya gönderdi.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "Melodi sizin, ses yeni. Bot iki seçeneği de sohbete, ayrı bir konuya gönderecek.",
    "Тут откроется тема чата, куда бот прислал кавер": "Burada botun cover’ı gönderdiği sohbet konusu açılacak",
    "Проверьте загрузку песни": "Şarkı yüklemesini kontrol edin",
    "Читаем длительность песни": "Şarkı süresi okunuyor",
    "Песня короче 6 секунд": "Şarkı 6 saniyeden kısa",
    "Выберите стиль": "Bir stil seçin",
    "Выберите голос с переозвучкой": "Yeniden seslendirme yapabilen bir ses seçin",
    "Фрагмент 1:00": "Kesit 1:00"
  },
  "kk": {
    "Создать кавер": "Кавер жасау",
    "Загрузите песню": "Әнді жүктеңіз",
    "Свою или ту, на которую у вас есть права": "Өзіңіздікін немесе құқығыңыз бар әнді",
    "с {0} до {1}": "{0} бастап {1} дейін",
    "Вся песня": "Бүкіл ән",
    "Двигайте окно, чтобы выбрать минуту": "Минутты таңдау үшін терезені жылжытыңыз",
    "Песня короче минуты: прозвучит целиком": "Ән бір минуттан қысқа: толық ойналады",
    "Кавер на всю песню": "Бүкіл әннің каверы",
    "Окно фрагмента: двигайте по волне": "Үзінді терезесі: толқын бойымен жылжытыңыз",
    "Выбрать из «Моих треков»": "«Менің тректерім» ішінен таңдау",
    "Оригинал": "Түпнұсқа",
    "Голос исполнителя без изменений": "Орындаушының дауысы өзгеріссіз",
    "Мой голос · клон": "Менің дауысым · клон",
    "Голоса с переозвучкой, подборки": "Қайта дыбыстай алатын дауыстар, топтамалар",
    "1 минута": "1 минут",
    "Пожелания к стилю": "Стильге тілектер",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Стильге не қосу керек. Мысалы: әйел вокалы, баяуырақ",
    "Без имён артистов": "Әртіс аттарынсыз",
    "Описание стиля": "Стиль сипаттамасы",
    "Опишите стиль": "Стильді сипаттаңыз",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Жанр, көңіл-күй, аспаптар. Мысалы: соул, тірі барабандар",
    "Словами, без имён артистов": "Сөзбен, әртіс аттарынсыз",
    "Читаем песню": "Әнді оқып жатырмыз",
    "Описание длиннее {0} знаков": "Сипаттама {0} таңбадан ұзын",
    "Пожелания к стилю длиннее {0} знаков": "Стильге тілектер {0} таңбадан ұзын",
    "Опишите стиль, от {0} знаков": "Стильді сипаттаңыз, кемінде {0} таңба",
    "Стили": "Стильдер",
    "Искать среди {0} стилей": "{0} стиль арасынан іздеу",
    "Мои треки": "Менің тректерім",
    "Каверы и аудио из «Истории»": "«Тарихтағы» каверлер мен аудио",
    "Свой стиль": "Өз стилім",
    "Стиль «{0}»": "«{0}» стилі",
    "голос {0}": "дауыс {0}",
    "голос как в оригинале": "түпнұсқадағыдай дауыс",
    "фрагмент с {0} до {1}": "{0} бастап {1} дейінгі үзінді",
    "вся песня": "бүкіл ән",
    "Слушать вариант {0}": "{0}-нұсқаны тыңдау",
    "Делаем кавер": "Кавер жасап жатырмыз",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Экраннан шыға беруге болады: кавер дайын болғанда бот жазады.",
    "Кавер готов": "Кавер дайын",
    "Изменить стиль": "Стильді өзгерту",
    "Заменить песню": "Әнді ауыстыру",
    "Права на песню": "Әнге құқық",
    "Только свои песни или песни с правами": "Тек өз әндеріңіз немесе құқығыңыз бар әндер",
    "Подтверждаю права на эту запись": "Осы жазбаға құқығымды растаймын",
    "Подтвердите права на песню": "Әнге құқығыңызды растаңыз",
    "Трек №{0}": "Трек №{0}",
    "Своя запись": "Өз жазбам",
    "Песня длиннее {0} минут": "Ән {0} минуттан ұзын",
    "Опишите жанр, настроение и инструменты": "Жанрды, көңіл-күйді және аспаптарды сипаттаңыз",
    "за песню": "ән үшін",
    "за фрагмент": "үзінді үшін",
    "до {0} минут": "{0} минутқа дейін",
    "любая минута песни": "әннің кез келген минуты",
    "Песня": "Ән",
    "за фрагмент {0}": "үзінді үшін {0}",
    "Создание кавера пока недоступно": "Кавер жасау әзірге қолжетімсіз",
    "Загружаем песню": "Әнді жүктеп жатырмыз",
    "Загрузите песню заново": "Әнді қайта жүктеңіз",
    "Песня короче {0} секунд": "Ән {0} секундтан қысқа",
    "Пока нет готовых треков": "Әзірге дайын тректер жоқ",
    "Не удалось загрузить «Мои треки».": "«Менің тректерім» жүктелмеді.",
    "Запись короче {0} секунд": "Жазба {0} секундтан қысқа",
    "Этот трек можно послушать в «Истории»": "Бұл тректі «Тарихта» тыңдауға болады",
    "Песня загружена": "Ән жүктелді",
    "Проверяем права": "Құқықтарды тексеріп жатырмыз",
    "Права проверены": "Құқықтар тексерілді",
    "Отделяем голос от музыки": "Дауысты музыкадан бөліп жатырмыз",
    "Голос отделён": "Дауыс бөлінді",
    "Играем в новом стиле": "Жаңа стильде ойнап жатырмыз",
    "Стиль готов": "Стиль дайын",
    "Сводим два варианта": "Екі нұсқаны біріктіріп жатырмыз",
    "Варианты готовы": "Нұсқалар дайын",
    "Песня не прошла проверку": "Ән тексеруден өтпеді",
    "Не получилось сделать кавер": "Кавер жасау мүмкін болмады",
    "кавер не создан": "кавер жасалмады",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Біреудің жазбасына ұқсайды: каверді тек өз әндеріңізге жасаймыз.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "Әуен сіздікі, дыбысы жаңа. Бот екі нұсқаны да чатқа, бөлек тақырыпқа жіберді.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "Әуен сіздікі, дыбысы жаңа. Бот екі нұсқаны да чатқа, бөлек тақырыпқа жібереді.",
    "Тут откроется тема чата, куда бот прислал кавер": "Мұнда бот каверді жіберген чат тақырыбы ашылады",
    "Проверьте загрузку песни": "Әннің жүктелуін тексеріңіз",
    "Читаем длительность песни": "Әннің ұзақтығын оқып жатырмыз",
    "Песня короче 6 секунд": "Ән 6 секундтан қысқа",
    "Выберите стиль": "Стильді таңдаңыз",
    "Выберите голос с переозвучкой": "Қайта дыбыстай алатын дауысты таңдаңыз",
    "Фрагмент 1:00": "Үзінді 1:00"
  },
  "uk": {
    "Создать кавер": "Створити кавер",
    "Загрузите песню": "Завантажте пісню",
    "Свою или ту, на которую у вас есть права": "Свою або ту, на яку у вас є права",
    "с {0} до {1}": "з {0} до {1}",
    "Вся песня": "Уся пісня",
    "Двигайте окно, чтобы выбрать минуту": "Пересувайте вікно, щоб вибрати хвилину",
    "Песня короче минуты: прозвучит целиком": "Пісня коротша за хвилину: прозвучить повністю",
    "Кавер на всю песню": "Кавер на всю пісню",
    "Окно фрагмента: двигайте по волне": "Вікно фрагмента: пересувайте по хвилі",
    "Выбрать из «Моих треков»": "Вибрати з «Моїх треків»",
    "Оригинал": "Оригінал",
    "Голос исполнителя без изменений": "Голос виконавця без змін",
    "Мой голос · клон": "Мій голос · клон",
    "Голоса с переозвучкой, подборки": "Голоси з переозвученням, добірки",
    "1 минута": "1 хвилина",
    "Пожелания к стилю": "Побажання до стилю",
    "Что добавить к стилю. Например: женский вокал, медленнее": "Що додати до стилю. Наприклад: жіночий вокал, повільніше",
    "Без имён артистов": "Без імен артистів",
    "Описание стиля": "Опис стилю",
    "Опишите стиль": "Опишіть стиль",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "Жанр, настрій, інструменти. Наприклад: соул, живі барабани",
    "Словами, без имён артистов": "Словами, без імен артистів",
    "Читаем песню": "Читаємо пісню",
    "Описание длиннее {0} знаков": "Опис довший за {0} знаків",
    "Пожелания к стилю длиннее {0} знаков": "Побажання до стилю довші за {0} знаків",
    "Опишите стиль, от {0} знаков": "Опишіть стиль, від {0} знаків",
    "Стили": "Стилі",
    "Искать среди {0} стилей": "Шукати серед {0} стилів",
    "Мои треки": "Мої треки",
    "Каверы и аудио из «Истории»": "Кавери та аудіо з «Історії»",
    "Свой стиль": "Свій стиль",
    "Стиль «{0}»": "Стиль «{0}»",
    "голос {0}": "голос {0}",
    "голос как в оригинале": "голос як в оригіналі",
    "фрагмент с {0} до {1}": "фрагмент з {0} до {1}",
    "вся песня": "уся пісня",
    "Слушать вариант {0}": "Слухати варіант {0}",
    "Делаем кавер": "Робимо кавер",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "Можна піти з екрана: бот напише, коли кавер буде готовий.",
    "Кавер готов": "Кавер готовий",
    "Изменить стиль": "Змінити стиль",
    "Заменить песню": "Замінити пісню",
    "Права на песню": "Права на пісню",
    "Только свои песни или песни с правами": "Лише свої пісні або пісні з правами",
    "Подтверждаю права на эту запись": "Підтверджую права на цей запис",
    "Подтвердите права на песню": "Підтвердьте права на пісню",
    "Трек №{0}": "Трек №{0}",
    "Своя запись": "Свій запис",
    "Песня длиннее {0} минут": "Пісня довша за {0} хвилин",
    "Опишите жанр, настроение и инструменты": "Опишіть жанр, настрій та інструменти",
    "за песню": "за пісню",
    "за фрагмент": "за фрагмент",
    "до {0} минут": "до {0} хвилин",
    "любая минута песни": "будь-яка хвилина пісні",
    "Песня": "Пісня",
    "за фрагмент {0}": "за фрагмент {0}",
    "Создание кавера пока недоступно": "Створення кавера поки недоступне",
    "Загружаем песню": "Завантажуємо пісню",
    "Загрузите песню заново": "Завантажте пісню ще раз",
    "Песня короче {0} секунд": "Пісня коротша за {0} секунд",
    "Пока нет готовых треков": "Поки немає готових треків",
    "Не удалось загрузить «Мои треки».": "Не вдалося завантажити «Мої треки».",
    "Запись короче {0} секунд": "Запис коротший за {0} секунд",
    "Этот трек можно послушать в «Истории»": "Цей трек можна послухати в «Історії»",
    "Песня загружена": "Пісню завантажено",
    "Проверяем права": "Перевіряємо права",
    "Права проверены": "Права перевірено",
    "Отделяем голос от музыки": "Відділяємо голос від музики",
    "Голос отделён": "Голос відділено",
    "Играем в новом стиле": "Граємо в новому стилі",
    "Стиль готов": "Стиль готовий",
    "Сводим два варианта": "Зводимо два варіанти",
    "Варианты готовы": "Варіанти готові",
    "Песня не прошла проверку": "Пісня не пройшла перевірку",
    "Не получилось сделать кавер": "Не вдалося зробити кавер",
    "кавер не создан": "кавер не створено",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "Схоже на чужий запис: кавери робимо лише на власні пісні.",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "Мелодія ваша, звучання нове. Бот уже надіслав обидва варіанти в чат, в окрему тему.",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "Мелодія ваша, звучання нове. Бот надішле обидва варіанти в чат, в окрему тему.",
    "Тут откроется тема чата, куда бот прислал кавер": "Тут відкриється тема чату, куди бот надіслав кавер",
    "Проверьте загрузку песни": "Перевірте завантаження пісні",
    "Читаем длительность песни": "Читаємо тривалість пісні",
    "Песня короче 6 секунд": "Пісня коротша за 6 секунд",
    "Выберите стиль": "Виберіть стиль",
    "Выберите голос с переозвучкой": "Виберіть голос з переозвученням",
    "Фрагмент 1:00": "Фрагмент 1:00"
  },
  "zh": {
    "Создать кавер": "创建翻唱",
    "Загрузите песню": "上传歌曲",
    "Свою или ту, на которую у вас есть права": "你自己的歌，或你拥有版权的歌",
    "с {0} до {1}": "从 {0} 到 {1}",
    "Вся песня": "整首歌",
    "Двигайте окно, чтобы выбрать минуту": "拖动窗口选择一分钟片段",
    "Песня короче минуты: прозвучит целиком": "歌曲不足一分钟：将完整播放",
    "Кавер на всю песню": "整首歌翻唱",
    "Окно фрагмента: двигайте по волне": "片段窗口：沿波形拖动",
    "Выбрать из «Моих треков»": "从「我的音轨」中选择",
    "Оригинал": "原声",
    "Голос исполнителя без изменений": "歌手原声，不做改变",
    "Мой голос · клон": "我的声音 · 克隆",
    "Голоса с переозвучкой, подборки": "支持变声的声音、合集",
    "1 минута": "1 分钟",
    "Пожелания к стилю": "风格要求",
    "Что добавить к стилю. Например: женский вокал, медленнее": "想给风格加点什么。例如：女声、慢一点",
    "Без имён артистов": "不要写歌手名字",
    "Описание стиля": "风格描述",
    "Опишите стиль": "描述风格",
    "Жанр, настроение, инструменты. Например: соул, живые барабаны": "曲风、情绪、乐器。例如：灵魂乐、现场鼓",
    "Словами, без имён артистов": "用文字描述，不写歌手名字",
    "Читаем песню": "正在读取歌曲",
    "Описание длиннее {0} знаков": "描述超过 {0} 个字符",
    "Пожелания к стилю длиннее {0} знаков": "风格要求超过 {0} 个字符",
    "Опишите стиль, от {0} знаков": "描述风格，至少 {0} 个字符",
    "Стили": "风格",
    "Искать среди {0} стилей": "在 {0} 种风格中搜索",
    "Мои треки": "我的音轨",
    "Каверы и аудио из «Истории»": "「历史」中的翻唱和音频",
    "Свой стиль": "自定义风格",
    "Стиль «{0}»": "风格「{0}」",
    "голос {0}": "声音 {0}",
    "голос как в оригинале": "保留原唱声音",
    "фрагмент с {0} до {1}": "片段 {0} 至 {1}",
    "вся песня": "整首歌",
    "Слушать вариант {0}": "试听版本 {0}",
    "Делаем кавер": "正在制作翻唱",
    "Можно уйти с экрана: бот напишет, когда кавер будет готов.": "可以离开此页面：翻唱完成后机器人会通知你。",
    "Кавер готов": "翻唱已完成",
    "Изменить стиль": "修改风格",
    "Заменить песню": "替换歌曲",
    "Права на песню": "歌曲版权",
    "Только свои песни или песни с правами": "仅限自己的歌曲或拥有版权的歌曲",
    "Подтверждаю права на эту запись": "我确认拥有这段录音的版权",
    "Подтвердите права на песню": "请确认歌曲版权",
    "Трек №{0}": "音轨 #{0}",
    "Своя запись": "我的录音",
    "Песня длиннее {0} минут": "歌曲超过 {0} 分钟",
    "Опишите жанр, настроение и инструменты": "描述曲风、情绪和乐器",
    "за песню": "每首歌",
    "за фрагмент": "每个片段",
    "до {0} минут": "最长 {0} 分钟",
    "любая минута песни": "歌曲中任意一分钟",
    "Песня": "歌曲",
    "за фрагмент {0}": "每个片段 {0}",
    "Создание кавера пока недоступно": "暂时无法创建翻唱",
    "Загружаем песню": "正在上传歌曲",
    "Загрузите песню заново": "请重新上传歌曲",
    "Песня короче {0} секунд": "歌曲短于 {0} 秒",
    "Пока нет готовых треков": "还没有完成的音轨",
    "Не удалось загрузить «Мои треки».": "无法加载「我的音轨」。",
    "Запись короче {0} секунд": "录音短于 {0} 秒",
    "Этот трек можно послушать в «Истории»": "可以在「历史」中试听这条音轨",
    "Песня загружена": "歌曲已上传",
    "Проверяем права": "正在检查版权",
    "Права проверены": "版权已检查",
    "Отделяем голос от музыки": "正在分离人声和伴奏",
    "Голос отделён": "人声已分离",
    "Играем в новом стиле": "正在用新风格演奏",
    "Стиль готов": "风格已就绪",
    "Сводим два варианта": "正在混音两个版本",
    "Варианты готовы": "版本已就绪",
    "Песня не прошла проверку": "歌曲未通过审核",
    "Не получилось сделать кавер": "翻唱制作失败",
    "кавер не создан": "翻唱未创建",
    "Похоже на чужую запись: каверы делаем только на свои песни.": "这似乎是别人的录音：我们只为你自己的歌曲制作翻唱。",
    "Мелодия ваша, звучание новое. Бот уже прислал оба варианта в чат, в отдельную тему.": "旋律是你的，声音是全新的。机器人已把两个版本发到聊天的单独话题中。",
    "Мелодия ваша, звучание новое. Бот пришлёт оба варианта в чат, в отдельную тему.": "旋律是你的，声音是全新的。机器人会把两个版本发到聊天的单独话题中。",
    "Тут откроется тема чата, куда бот прислал кавер": "这里会打开机器人发送翻唱的聊天话题",
    "Проверьте загрузку песни": "检查歌曲上传",
    "Читаем длительность песни": "正在读取歌曲时长",
    "Песня короче 6 секунд": "歌曲短于 6 秒",
    "Выберите стиль": "选择风格",
    "Выберите голос с переозвучкой": "选择支持变声的声音",
    "Фрагмент 1:00": "片段 1:00"
  }
}
